const FAMILY_CODE = '[A-Za-z]{1,4}(?:\\.[A-Za-z0-9]+)*'

/** Split "Ia - Identification…" or a source like "ISO 27001 | A.6" into code + name. */
export function splitFamilyLabel(
  raw: string,
  source = ''
): { code: string; full?: string; source: string } {
  const text = raw.trim()
  const src = source.trim()

  const dashed = text.match(
    new RegExp(`^(${FAMILY_CODE})\\s*[-–—:|]\\s+(.+)$`)
  )
  if (dashed) {
    return { code: dashed[1], full: dashed[2].trim(), source: src }
  }

  const tight = text.match(new RegExp(`^(${FAMILY_CODE})-(.+)$`))
  if (tight && tight[2].trim()) {
    return { code: tight[1], full: tight[2].trim(), source: src }
  }

  const fromSource = src.match(
    new RegExp(`^(.*?)\\s*\\|\\s*(${FAMILY_CODE})\\s*$`)
  )
  if (fromSource && text) {
    return {
      code: fromSource[2],
      full: text,
      source: fromSource[1].trim() || src,
    }
  }

  if (new RegExp(`^${FAMILY_CODE}$`).test(text)) {
    return { code: text, source: src }
  }

  return { code: text || '—', source: src }
}
